import Radio from '@mui/material/Radio';
import { styled, useTheme } from '@mui/material/styles';
import React from 'react';

interface CustomRadioIconProps {
  checked: boolean;
}

function CustomRadioIcon({ checked }: CustomRadioIconProps) {
  const theme = useTheme();
  const colors = theme.palette.radio || {};
  return (
    <span
      style={{
        display: 'inline-block',
        width: 20,
        height: 20,
        borderRadius: '50%',
        border: checked ? `2px solid ${colors.borderChecked}` : `2px solid ${colors.borderDefault}`,
        background: colors.background,
        boxSizing: 'border-box',
        position: 'relative',
        transition: `border-color ${theme.transitions.custom.fast}`,
      }}
    >
      {checked && (
        <span
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: 10,
            height: 10,
            background: colors.dot,
            borderRadius: '50%',
            transform: 'translate(-50%,-50%)',
            display: 'block',
          }}
        />
      )}
    </span>
  );
}

const CustomRadio = styled((props: any) => (
  <Radio
    disableRipple
    color="default"
    checkedIcon={<CustomRadioIcon checked={true} />}
    icon={<CustomRadioIcon checked={false} />}
    {...props}
  />
))(() => ({
  padding: 0,
}));

interface RadioButtonProps {
  checked: boolean;
  onChange: (_event: React.ChangeEvent<HTMLInputElement>, _checked: boolean) => void;
  label: string;
  [key: string]: any;
}

const RadioButton: React.FC<RadioButtonProps> = React.memo(function RadioButton({
  checked,
  onChange,
  label,
  ...props
}) {
  const theme = useTheme();
  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        gap: '8px',
      }}
    >
      <CustomRadio
        checked={checked}
        onChange={onChange}
        {...props}
        inputProps={{ 'aria-label': label }}
      />
      <span
        style={{
          fontWeight: 400,
          fontSize: '15px',
          lineHeight: '21px',
          letterSpacing: '0px',
          color: theme.palette.radio?.label || 'rgba(17,28,45,0.8)',
          userSelect: 'none',
        }}
      >
        {label}
      </span>
    </label>
  );
});

export default RadioButton;
